/* unplugin-vue-components disabled */import script from "./AnnouncementDetailContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementDetailContent.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementDetailContent.vue?vue&type=style&index=0&id=4fded1a3&scoped=true&lang=css"
import "../../departments/organization-shared.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fded1a3"]])

export default __exports__